import { useEffect, useState } from 'react'
import { useOptionalAviosAuth } from '@channel/shared-header-footer/auth-client'
import { useAviosAuthEnabled } from '~/context/auth'

type UseAviosAuthBalanceResult = {
  aviosAuthBalance: number | undefined
  householdAuthBalance: number | undefined
  isAviosBalanceLoading: boolean
}

export const useAviosAuthBalance = (): UseAviosAuthBalanceResult => {
  const aviosAuthEnabled = useAviosAuthEnabled()
  const aviosAuth = useOptionalAviosAuth()
  const getAviosBalance = aviosAuth?.getBalance

  const [aviosAuthBalance, setAviosAuthBalance] = useState<number | undefined>(undefined)
  const [householdAuthBalance, setHouseholdAuthBalance] = useState<number | undefined>(undefined)
  const [isAviosBalanceLoading, setIsAviosBalanceLoading] = useState<boolean>(aviosAuthEnabled)

  useEffect(() => {
    if (!aviosAuthEnabled || !getAviosBalance) {
      setIsAviosBalanceLoading(false)
      return
    }
    getAviosBalance()
      .then((balanceData) => {
        const numericBalance =
          typeof balanceData === 'number'
            ? balanceData
            : (balanceData as { balance?: number } | null)?.balance ?? undefined

        const numericHouseholdBalance =
          typeof balanceData === 'number'
            ? balanceData
            : (balanceData as { household?: number } | null)?.household ?? undefined
        setAviosAuthBalance(numericBalance)
        setHouseholdAuthBalance(numericHouseholdBalance)
        setIsAviosBalanceLoading(false)
      })
      .catch(() => {
        setIsAviosBalanceLoading(false)
      })
  }, [aviosAuthEnabled, getAviosBalance])

  return { aviosAuthBalance, householdAuthBalance, isAviosBalanceLoading }
}
